import { useState, createContext, useContext } from "react";

const FormPopupContext = createContext();

export function FormPopupProvider({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <FormPopupContext.Provider value={{ open, setOpen }}>
      {children}
    </FormPopupContext.Provider>
  );
}

export function useFormPopup() {
  return useContext(FormPopupContext);
}
